import * as React from 'react';
import List from '../NavigationList';
import { ListItemButton, ListItemIcon, ListItemText, Icon, Divider } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SearchIcon from '@mui/icons-material/Search';
import { selectUser } from '../../../slices/global/authSlice';
import { signinRedirect, signoutRedirect } from '../../../services/userService';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { alertError } from '../../../slices/global/alertSlice';
import { selectTheme, toggleTheme } from '../../../slices/global/themeSlice';

export default function BottomNavigation() {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const theme = useAppSelector(selectTheme);

  function signOut() {
    signoutRedirect();
  }
  function login() {
    signinRedirect(handleError);
  }

  function handleError() {
    dispatch(alertError('Login Failed. Try again'));
  }
  return (
    <List dense>
      <ListItemButton onClick={() => (user ? signOut() : login())} sx={{ maxHeight: 35 }}>
        <ListItemIcon>
          {user ? <LogoutIcon fontSize="small" /> : <LoginIcon fontSize="small" />}
        </ListItemIcon>
        <ListItemText
          primary={!user ? 'Log In' : 'Log Out'}
          primaryTypographyProps={{ fontSize: 12 }}
        />
      </ListItemButton>
      <ListItemButton component="a" href="https://tracking.autoshack.com" sx={{ maxHeight: 35 }}>
        <ListItemIcon>
          <LocalShippingIcon />
        </ListItemIcon>
        <ListItemText primary="Go to Tracking" primaryTypographyProps={{ fontSize: 12 }} />
      </ListItemButton>
      <ListItemButton component="a" href="https://purchasing.autoshack.com" sx={{ maxHeight: 35 }}>
        <ListItemIcon>
          <ShoppingBasketIcon />
        </ListItemIcon>
        <ListItemText primary="Go to Purchasing" primaryTypographyProps={{ fontSize: 12 }} />
      </ListItemButton>
      <ListItemButton component="a" href="https://listing.autoshack.com" sx={{ maxHeight: 35 }}>
        <ListItemIcon>
          <SearchIcon />
        </ListItemIcon>
        <ListItemText primary="Go to Listing" primaryTypographyProps={{ fontSize: 12 }} />
      </ListItemButton>
      <Divider component="div" role="presentation" sx={{ bgcolor: 'lightGrey', mb: 1 }} />
      <ListItemButton onClick={() => dispatch(toggleTheme())}>
        <ListItemIcon>
          <Icon>{theme === 'light' ? 'light_mode' : 'dark_mode'}</Icon>
        </ListItemIcon>
        <ListItemText
          primary={theme === 'light' ? 'Light Mode' : 'Dark Mode'}
          primaryTypographyProps={{ fontSize: 12 }}
        />
      </ListItemButton>
    </List>
  );
}
